import { baseUrl, extendHeaders } from "./HelpService";


const PageUrl = baseUrl + 'dashboard/';

const getDashboard = (accountId: number): Promise<Response | null> => {
    return fetch(`${PageUrl}getDashboard/?account_id=${encodeURIComponent(accountId)}`, {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};


const DashboardService = {
    getDashboard
};

export default DashboardService;
